export default __webpack_public_path__ + "static/media/lapalme-logo.4cebe7b3.png";